<template>
    <el-scrollbar wrap-class="scrollbar-wrapper" id="domSideBar">
      <el-menu
        :show-timeout="200"
        :default-active="routerPath"
        :collapse="isCollapse"
        :unique-opened="true"
        mode="vertical"
        background-color="#fff"
        text-color="#333"
        active-text-color="#5143EB"
        class="menu-wrapper"
      >
      <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path"/>
      <div class="menu-wrapper">
        <li role="menuitem" aria-haspopup="true" class="el-submenu">
          <a target="_blank" href="https://www.xyab.cn">
          <div class="el-submenu__title" style="padding-left: 20px; color: rgb(51, 51, 51); background-color: rgb(255, 255, 255);">
            <i class="iconfont iconshouye" style="font-size: 18px;"/>
            <span>返回官网首页</span>
          </div>
          </a>
        </li>
      </div>
      </el-menu>
      <!-- <div><span>返回官网首页</span></div> -->
    </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    routerPath(){
      return this.$route.meta.guidePath ? this.$route.meta.jumpPath : this.$route.path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue